/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Knp_Lookup_Edit_HelpInputs */

const en_knp_lookup_edit_help = /** @type {(inputs: Knp_Lookup_Edit_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Double-click any cell to edit. Click "Save" to commit changes.`)
};

const fr_knp_lookup_edit_help = /** @type {(inputs: Knp_Lookup_Edit_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Double-cliquez sur une cellule pour modifier. Cliquez sur "Enregistrer" pour valider les changements.`)
};

const de_knp_lookup_edit_help = /** @type {(inputs: Knp_Lookup_Edit_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Doppelklicken Sie auf eine beliebige Zelle, um sie zu bearbeiten. Klicken Sie auf „Speichern“, um die Änderungen zu übernehmen.`)
};

const it_knp_lookup_edit_help = /** @type {(inputs: Knp_Lookup_Edit_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fare doppio clic su una cella qualsiasi per modificarla. Fare clic su "Salva" per salvare le modifiche.`)
};

const ru_knp_lookup_edit_help = /** @type {(inputs: Knp_Lookup_Edit_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Для редактирования дважды щелкните любую ячейку. Нажмите «Сохранить», чтобы подтвердить изменения.`)
};

const es_knp_lookup_edit_help = /** @type {(inputs: Knp_Lookup_Edit_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Haga doble clic en cualquier celda para editarla. Haga clic en "Guardar" para confirmar los cambios.`)
};

const zh_cn2_knp_lookup_edit_help = /** @type {(inputs: Knp_Lookup_Edit_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`双击任意单元格即可编辑。点击“保存”按钮提交更改。`)
};

const ja_knp_lookup_edit_help = /** @type {(inputs: Knp_Lookup_Edit_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`編集するには、任意のセルをダブルクリックしてください。「保存」をクリックして変更を確定してください。`)
};

const hi_knp_lookup_edit_help = /** @type {(inputs: Knp_Lookup_Edit_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`किसी भी सेल को संपादित करने के लिए उस पर दो बार क्लिक करें। परिवर्तन को सेव करने के लिए "सेव" पर क्लिक करें।`)
};

const pt_pt2_knp_lookup_edit_help = /** @type {(inputs: Knp_Lookup_Edit_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Clique duas vezes em qualquer célula para editar. Clique em "Salvar" para confirmar as alterações.`)
};

/**
* | output |
* | --- |
* | "Double-click any cell to edit. Click \"Save\" to commit changes." |
*
* @param {Knp_Lookup_Edit_HelpInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const knp_lookup_edit_help = /** @type {((inputs?: Knp_Lookup_Edit_HelpInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Knp_Lookup_Edit_HelpInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_knp_lookup_edit_help(inputs)
	if (locale === "de") return de_knp_lookup_edit_help(inputs)
	if (locale === "it") return it_knp_lookup_edit_help(inputs)
	if (locale === "ru") return ru_knp_lookup_edit_help(inputs)
	if (locale === "es") return es_knp_lookup_edit_help(inputs)
	if (locale === "zh-CN") return zh_cn2_knp_lookup_edit_help(inputs)
	if (locale === "ja") return ja_knp_lookup_edit_help(inputs)
	if (locale === "hi") return hi_knp_lookup_edit_help(inputs)
	if (locale === "pt-PT") return pt_pt2_knp_lookup_edit_help(inputs)
	return en_knp_lookup_edit_help(inputs)
});